import fetch from "auth/FetchInterceptorAppManager";
import { useSelector } from "react-redux";

const GroupMenuService = {};

GroupMenuService.getUserMenuList = function (branchId) {
  // var branchId = localStorage.getItem("branchId") || 0;
  return fetch({
    url: "am/usermenu?groupdbid=" + branchId,
    method: "get",
  });
};

export default GroupMenuService;
